import React, { useState } from 'react';
import { functionTexts } from '../contexts/LangOIT';
import monitoringImg from '../assets/images/observeit/monitoring.png'; // monitoring.png 추가
import detectionImg from '../assets/images/observeit/detection.png'; // monitoring.png 추가
import recordingImg from '../assets/images/observeit/recording.png'; // recording.png 추가
import policyImg from '../assets/images/observeit/policy.png'; // policy.png 추가
import auditImg from '../assets/images/observeit/audit.png'; // audit.png 추가
import oitDashboardImg from '../assets/images/observeit/oit_dashboard.png'; // 이미지 import

function ProductOITFunction({ lang = 'ko', isMobile = false }) {
  const [monitoringHover, setMonitoringHover] = useState(false);
  const [detectionHover, setDetectionHover] = useState(false);
  const [policyHover, setPolicyHover] = useState(false);
  const [recordingHover, setRecordingHover] = useState(false);
  const [auditHover, setAuditHover] = useState(false);
  const [dashboardHover, setDashboardHover] = useState(false); // 6번 박스용 상태 추가

  return (
    <div
      style={{
        width: '100%',
        maxWidth: '100%',
        background: '#3a3570',
        borderRadius: 12,
        boxShadow: '0 2px 12px rgba(0,0,0,0.10)',
        padding: '0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        overflowX: 'hidden'
      }}
    >
      <span style={{
        fontSize: isMobile ? '1.5rem' : '2rem',
        fontWeight: 700,
        color: '#fff',
        marginBottom: isMobile ? 12 : 16,
        paddingLeft: isMobile ? 20 : 40,
        paddingTop: isMobile ? 20 : 28,
        display: 'block',
        lineHeight: 1.3,
        textAlign: 'center',
        width: '100%'
      }}>
        {functionTexts.title[lang]}
      </span>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
          gap: isMobile ? '20px' : '32px',
          width: '100%',
          maxWidth: '1550px',
          margin: '0 auto',
          padding: isMobile ? '20px 16px 30px 16px' : '32px 16px 40px 16px',
          boxSizing: 'border-box'
        }}
        className="oit-function-grid"
      >
        {/* 1번 박스 */}
        <div
          style={{
            background: '#035BFB',
            borderRadius: 10,
            boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
            padding: '32px 24px',
            fontSize: '1.2rem',
            fontWeight: 600,
            color: '#fff',
            minHeight: 320,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-start',
            textAlign: 'center',
            position: 'relative'
          }}
          onMouseEnter={() => setMonitoringHover(true)}
          onMouseLeave={() => setMonitoringHover(false)}
        >
          <div style={{
            fontSize: '1.15rem',
            fontWeight: 700,
            marginBottom: 16
          }}>
            {functionTexts.monitoring.title[lang]}
          </div>
          <div style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            position: 'relative'
          }}>
            <img
              src={monitoringImg}
              alt="Monitoring"
              style={{
                width: '100%',
                height: 'auto',
                maxWidth: '420px',
                maxHeight: '280px',
                objectFit: 'contain',
                display: 'block'
              }}
            />
            {monitoringHover && (
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  background: 'rgba(34,34,34,0.65)', // 더 반투명하게
                  color: '#fff',
                  borderRadius: 10,
                  boxSizing: 'border-box', // 박스 크기 유지
                  padding: '24px 20px',
                  fontSize: '1rem',
                  display: 'flex',
                  alignItems: 'flex-start',
                  justifyContent: 'flex-start',
                  textAlign: 'left',
                  zIndex: 2,
                  overflowY: 'auto'
                }}
              >
                {functionTexts.monitoring.desc[lang]}
              </div>
            )}
          </div>
        </div>
        {/* 2번 박스 */}
        <div
          style={{
            background: '#035BFB',
            borderRadius: 10,
            boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
            padding: '32px 24px',
            fontSize: '1.2rem',
            fontWeight: 600,
            color: '#fff',
            minHeight: 320,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-start',
            textAlign: 'center',
            position: 'relative'
          }}
          onMouseEnter={() => setDetectionHover(true)}
          onMouseLeave={() => setDetectionHover(false)}
        >
          <div style={{
            fontSize: '1.15rem',
            fontWeight: 700,
            marginBottom: 16
          }}>
            {functionTexts.detection.title[lang]}
          </div>
          <div style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            position: 'relative'
          }}>
            <img
              src={detectionImg}
              alt="Detection"
              style={{
                width: '100%',
                height: 'auto',
                maxWidth: '420px',
                maxHeight: '280px',
                objectFit: 'contain',
                display: 'block'
              }}
            />
            {detectionHover && (
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  background: 'rgba(34,34,34,0.65)', // 더 반투명하게
                  color: '#fff',
                  borderRadius: 10,
                  boxSizing: 'border-box', // 박스 크기 유지
                  padding: '24px 20px',
                  fontSize: '1rem',
                  display: 'flex',
                  alignItems: 'flex-start',
                  justifyContent: 'flex-start',
                  textAlign: 'left',
                  zIndex: 2,
                  overflowY: 'auto'
                }}
              >
                {functionTexts.detection.desc[lang]}
              </div>
            )}
          </div>
        </div>
        {/* 3번 박스 */}
        <div
          style={{
            background: '#035BFB',
            borderRadius: 10,
            boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
            padding: '32px 24px',
            fontSize: '1.2rem',
            fontWeight: 600,
            color: '#fff',
            minHeight: 320,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-start',
            textAlign: 'center',
            position: 'relative'
          }}
          onMouseEnter={() => setPolicyHover(true)}
          onMouseLeave={() => setPolicyHover(false)}
        >
          <div style={{
            fontSize: '1.15rem',
            fontWeight: 700,
            marginBottom: 16
          }}>
            {functionTexts.policy.title[lang]}
          </div>
          <div style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            position: 'relative'
          }}>
            <img
              src={policyImg}
              alt="Policy"
              style={{
                width: '100%',
                height: 'auto',
                maxWidth: '420px',
                maxHeight: '280px',
                objectFit: 'contain',
                display: 'block'
              }}
            />
            {policyHover && (
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  background: 'rgba(34,34,34,0.65)',
                  color: '#fff',
                  borderRadius: 10,
                  boxSizing: 'border-box', // 박스 크기 유지
                  padding: '24px 20px',
                  fontSize: '1rem',
                  display: 'flex',
                  alignItems: 'flex-start',
                  justifyContent: 'flex-start',
                  textAlign: 'left',
                  zIndex: 2,
                  overflowY: 'auto'
                }}
              >
                {functionTexts.policy.desc[lang]}
              </div>
            )}
          </div>
        </div>
        {/* 4번 박스 */}
        <div
          style={{
            background: '#035BFB',
            borderRadius: 10,
            boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
            padding: '32px 24px',
            fontSize: '1.2rem',
            fontWeight: 600,
            color: '#fff',
            minHeight: 320,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-start',
            textAlign: 'center',
            position: 'relative'
          }}
          onMouseEnter={() => setRecordingHover(true)}
          onMouseLeave={() => setRecordingHover(false)}
        >
          <div style={{
            fontSize: '1.15rem',
            fontWeight: 700,
            marginBottom: 16
          }}>
            {functionTexts.recording.title[lang]}
          </div>
          <div style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            position: 'relative'
          }}>
            <img
              src={recordingImg}
              alt="Recording"
              style={{
                width: '100%',
                height: 'auto',
                maxWidth: '420px',
                maxHeight: '280px',
                objectFit: 'contain',
                display: 'block'
              }}
            />
            {recordingHover && (
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  background: 'rgba(34,34,34,0.65)',
                  color: '#fff',
                  borderRadius: 10,
                  boxSizing: 'border-box', // 박스 크기 유지
                  padding: '24px 20px',
                  fontSize: '1rem',
                  display: 'flex',
                  alignItems: 'flex-start',
                  justifyContent: 'flex-start',
                  textAlign: 'left',
                  zIndex: 2,
                  overflowY: 'auto'
                }}
              >
                {functionTexts.recording.desc[lang]}
              </div>
            )}
          </div>
        </div>
        {/* 5번 박스 */}
        <div
          style={{
            background: '#035BFB',
            borderRadius: 10,
            boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
            padding: '32px 24px',
            fontSize: '1.2rem',
            fontWeight: 600,
            color: '#fff',
            minHeight: 320,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-start',
            textAlign: 'center',
            position: 'relative'
          }}
          onMouseEnter={() => setAuditHover(true)}
          onMouseLeave={() => setAuditHover(false)}
        >
          <div style={{
            fontSize: '1.15rem',
            fontWeight: 700,
            marginBottom: 16
          }}>
            {functionTexts.audit.title[lang]}
          </div>
          <div style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            position: 'relative'
          }}>
            <img
              src={auditImg}
              alt="Audit"
              style={{
                width: '100%',
                height: 'auto',
                maxWidth: '420px',
                maxHeight: '280px',
                objectFit: 'contain',
                display: 'block'
              }}
            />
            {auditHover && (
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  background: 'rgba(34,34,34,0.65)',
                  color: '#fff',
                  borderRadius: 10,
                  boxSizing: 'border-box', // 박스 크기 유지
                  padding: '24px 20px',
                  fontSize: '1rem',
                  display: 'flex',
                  alignItems: 'flex-start',
                  justifyContent: 'flex-start',
                  textAlign: 'left',
                  zIndex: 2,
                  overflowY: 'auto'
                }}
              >
                {functionTexts.audit.desc[lang]}
              </div>
            )}
          </div>
        </div>
        {/* 6번 박스 */}
        <div
          style={{
            background: '#035BFB',
            borderRadius: 10,
            boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
            padding: '32px 24px',
            fontSize: '1.2rem',
            fontWeight: 600,
            color: '#fff',
            minHeight: 320,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-start',
            textAlign: 'center',
            position: 'relative'
          }}
          onMouseEnter={() => setDashboardHover(true)}
          onMouseLeave={() => setDashboardHover(false)}
        >
          <div style={{
            fontSize: '1.15rem',
            fontWeight: 700,
            marginBottom: 16
          }}>
            {functionTexts.dashboard.title[lang]}
          </div>
          <div style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            position: 'relative'
          }}>
            <img
              src={oitDashboardImg}
              alt="ObserveIT Dashboard"
              style={{
                width: '100%',
                height: 'auto',
                maxWidth: '420px',
                maxHeight: '280px',
                objectFit: 'contain',
                display: 'block'
              }}
            />
            {dashboardHover && (
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  background: 'rgba(34,34,34,0.65)',
                  color: '#fff',
                  borderRadius: 10,
                  boxSizing: 'border-box', // 박스 크기 유지
                  padding: '24px 20px',
                  fontSize: '1rem',
                  display: 'flex',
                  alignItems: 'flex-start',
                  justifyContent: 'flex-start',
                  textAlign: 'left',
                  zIndex: 2,
                  overflowY: 'auto'
                }}
              >
                {functionTexts.dashboard.desc[lang]}
              </div>
            )}
          </div>
        </div>
      </div>
      <style>
        {`
          @media (max-width: 900px) {
            .oit-function-grid {
              grid-template-columns: 1fr 1fr !important; /* 2열로 */
            }
          }
          @media (max-width: 600px) {
            .oit-function-grid {
              grid-template-columns: 1fr !important; /* 1열로 */
            }
          }
        `}
      </style>
    </div>
  );
}

export default ProductOITFunction;